import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
 import { MatMenuModule } from '@angular/material/menu';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MatDialogConfig
} from '@angular/material/dialog';

import { StripeAPIService } from '../../services/stripe-api.service';
import { AmplifyModelService } from '../../services/amplify-model-service.service';
import { StripeCustomerSubscriptionsComponent } from '../stripe-customer-subscriptions/stripe-customer-subscriptions.component';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { StripeBody } from '../create-subscription-dialog/create-subscription-dialog.component';
import { SubscriptionBuilderComponent, SubBuilderData } from '../subscription-builder/subscription-builder.component';
import { SubscriptionEditorComponent } from '../subscription-editor/subscription-editor.component';
import { CustomerCreditDialogComponent, CustomerCreditData } from '../customer-credit-dialog/customer-credit-dialog.component';
import { InvoiceItemDialogComponent, InvoiceItemData } from '../invoice-item-dialog/invoice-item-dialog.component';

/** adding a comment to push to MatIconModule **/

@Component({
  selector: 'app-stripe-customer',
  imports: [DynamicFormComponent, StripeCustomerSubscriptionsComponent, MatIconModule, MatToolbarModule, MatButtonModule, MatMenuModule],
  templateUrl: './stripe-customer.component.html',
  styleUrl: './stripe-customer.component.css'
})
export class StripeCustomerComponent implements OnInit {

  customer: any = null;
  customerStripeId: string = '';
  customerId: string = '';
  readonly dialog = inject(MatDialog);
  dialogConfig:any = new MatDialogConfig();
  private ams = inject(AmplifyModelService);
  //

  constructor(private stripeApi: StripeAPIService, private route: ActivatedRoute) { }

  serviceCustomers: any[] = [];

  ngOnInit() {
    //this.stripeApi.getItem('customer', 'customer-id');
    var customerId = this.route.snapshot.paramMap.get('id');
    if (customerId){
      this.customerId = customerId;
    }
    this.dialogConfig.width = '600px';
  }

  handleItemOutput(customer: any) {
    console.log('handleItemOutput customer', customer);
    this.customer = customer;
    this.customerStripeId = customer.stripe_id;
  }

  handleRelationshipOutput(event) {
    console.log('handleRelationshipOutput heard event', event);
    if (Array.isArray(event)) {
      this.serviceCustomers = event
    }
    console.log('serviceCustomers', this.serviceCustomers);
  }

  handleCardClick(event: any){
    console.log('handleCardClick event', event);
    if (event.action == 'edit'){
      console.log('edit clicked with event', event);
      this.openSubscriptionEditor(event.card);
    }
  }

  /**
   * Fix A (customer/Stripe id race): this.customer can be stale by the time
   * the user clicks "Add Subscription" - it was set once, from
   * handleItemOutput(), right after the Customer record was created/loaded,
   * and is never refreshed. The dynamo_stripe Lambda (DynamoDB Streams ->
   * Stripe customer create -> write stripe_id back) runs asynchronously and
   * can easily still be in flight at that point, so this.customer.stripe_id
   * can be missing even though the Customer *does* already have a Stripe
   * customer underway. Re-fetching immediately before opening the builder
   * gives CreateSubscriptionDialogComponent the best available snapshot,
   * without needing to change how/when this.customer is normally set.
   */
  private async getFreshCustomer(): Promise<any> {
    let current = this.customer || this.serviceCustomers[0]?.customer;
    if (!current?.id) return current || '';

    try {
      const response = await this.ams.getItemForModel('Customer', current.id);
      if (response?.data) {
        this.customer = response.data;
        this.customerStripeId = response.data.stripe_id;
        return response.data;
      }
    } catch (error) {
      console.error('getFreshCustomer - failed to refresh customer, using cached value', error);
    }
    return current;
  }

  async openSubscriptionBuilder(stripeBody?: StripeBody): Promise<void> {
    console.log('openSubscriptionBuilder clicked serviceCustomers', this.serviceCustomers);
    let builderData:SubBuilderData = {
      entitlements: this.serviceCustomers,
      customer: await this.getFreshCustomer()
    };

    if (stripeBody){
      builderData.stripeBody = stripeBody;
    }
    this.dialogConfig.width = '60vw';
    this.dialogConfig.data = builderData;

    const dialogRef = this.dialog.open(SubscriptionBuilderComponent, this.dialogConfig);//{data: builderData});

    dialogRef.afterClosed().subscribe(result => {
      if (result) console.log('result', result)
    });
  }


  openSubscriptionEditor(stripeBody?: StripeBody): void {
    console.log('openSubscriptionEditor clicked stripeBody', stripeBody);
    let builderData:SubBuilderData = {
      customer: this.customer || this.serviceCustomers[0].customer || ''
    };

    if (stripeBody){
      builderData.stripeBody = stripeBody;
    }
    this.dialogConfig.width = 'auto';
    this.dialogConfig.data = builderData;

    const dialogRef = this.dialog.open(SubscriptionEditorComponent, this.dialogConfig);//{data: builderData});

    dialogRef.afterClosed().subscribe(result => {
      if (result) console.log('result', result)
    });
  }

  openCustomerCreditDialog () {
    console.log('will openCustomerCreditDialog');
    let creditData:CustomerCreditData = {
      customer: this.customer || this.serviceCustomers[0].customer || ''
    };
    this.dialogConfig.data = creditData;

    const dialogRef = this.dialog.open(CustomerCreditDialogComponent, this.dialogConfig); //{data: creditData});

    dialogRef.afterClosed().subscribe(result => {
      if (result) console.log('result', result)
    });
  }

  openInvoiceItemDialog () {
    console.log('will openInvoiceItemDialog');
    let invoiceData:InvoiceItemData = {
      customer: this.customer || this.serviceCustomers[0].customer || ''
    };
    this.dialogConfig.data = invoiceData;

    const dialogRef = this.dialog.open(InvoiceItemDialogComponent, this.dialogConfig);//{data: invoiceData});

    dialogRef.afterClosed().subscribe(result => {
      if (result) console.log('result', result)
    });
  }


}
